export const LOAD_VIEW_CONFIG = 'LOAD_VIEW_CONFIG';
export const LOAD_VIEW_CONFIG_FAILURE = 'LOAD_VIEW_CONFIG_FAILURE';
export const LOAD_VIEW_CONFIG_SUCCESS = 'LOAD_VIEW_CONFIG_SUCCESS';
export const VIEW_CONFIG_LOADING = 'VIEW_CONFIG_LOADING';
export const RELOAD_VIEW_CONFIG_FROM_LOCALSTORAGE = 'RELOAD_VIEW_CONFIG_FROM_LOCALSTORAGE';
